import { render, staticRenderFns } from "./authAdd.vue?vue&type=template&id=5e646eee&scoped=true&"
import script from "./authAdd.vue?vue&type=script&lang=js&"
export * from "./authAdd.vue?vue&type=script&lang=js&"
import style0 from "./authAdd.vue?vue&type=style&index=0&id=5e646eee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e646eee",
  null
  
)

export default component.exports